<template>
    <div class="hl-loader-container">
        <RingLoader />
        <div class="hl-loader-info">
            {{ $store.state.locationLoaderActive ? $t('campaign.loader.loadingNewSubAccountData') : $t('campaign.loader.loadingFreshData') }}
        </div>
        <div>
            <div class="hl-loader-error" v-if="enableAdvanceOption">
                <div class="error-msg">{{ $t('campaign.loader.issuesLoadingApp') }}
                    <span class="error-action" @click="reload">
                        {{ $t('campaign.loader.clickHereToRefresh') }}
                    </span>
                </div>

            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import RingLoader from './RingLoader.vue';

import { customLogger } from '../../plugins/sentry/customLogger';

export default defineComponent({
    name: 'AppLoader',
    props: {
        user: Object
    },
    components: {
        RingLoader,
    },
    computed: {
        enableAdvanceOption() {
            const enableReload = this.$store.state.loaderCount === 0 && (this.$store.state.locationLoaderActive || this.$store.state.agencyLoaderActive)
            if (enableReload) {
                customLogger({
                    message: 'Delayed_App_Load',
                    level: 'info',
                     tags: {
                        user_id: this.user?.id,
                        locationLoader: this.$store.state.locationLoaderActive,
                        agencyLoader: this.$store.state.agencyLoaderActive,
                        locationId: this.$route.params.location_id ?? ''
                    }
                })
            }
            return enableReload
        },
    },
    methods: {
        reload() {
            customLogger({message: 'forced_app_reload', level: 'info', tags: {
                user_id: this.user?.id,
                locationLoader: this.$store.state.locationLoaderActive,
                agencyLoader: this.$store.state.agencyLoaderActive,
                locationId: this.$route.params.location_id ?? ''
            }})
            localStorage.clear()
            localStorage.clear()
            sessionStorage.clear()
            document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
            window.location.reload()
        },
    },
})

</script>
<style lang="scss">
.hl-loader-error {
    .error-msg {
        font-size: 14px;
        font-weight: 400;
        margin-top: 20px;
    }

    .error-action {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 500;
        color: #007bff;
        cursor: pointer;
    }
}
</style>